export default __webpack_public_path__ + "static/media/NIAS0520.34I-38771_-22685_0.7d52b841.jpg";